import React from 'react'
import { ComunicatiType } from '@next-nx/utils/types'
import styles from './ComunicatoCard.module.sass'
import { getAnchorRel } from '@next-nx/utils'

interface Props {
  comunicato: ComunicatiType
  className?: string
}

const ComunicatoCard = (props: Props) => {
  const { comunicato = undefined, className = '' } = props

  return comunicato ? (
    <div className={styles.layout}>
      <div className={styles.content}>
        <div className={styles.dataPubblicazione}>{comunicato.dataPubblicazione}</div>
        <div className={styles.titolo}>
          <a href={comunicato.url} rel={getAnchorRel(comunicato.url)}>
            {comunicato.titolo}
          </a>
        </div>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default ComunicatoCard
